import React, { Fragment } from "react";

export default function ProfileParent({ children }) {
  return <Fragment>{children}</Fragment>;
}
